//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.service('ItemHistoryService', [
    '$http',
    'PromiseService',
    function(
            $http,
            PromiseService,
        ) {
      this.getItemHistory = function(itemId) {
        return PromiseService.processHttpResponse($http.get(`/api/item-history/${itemId}`));
      };
    },
  ]);
})();
